<script setup>
import { useSlots } from 'vue'

const slots = useSlots()
const props = defineProps({
  transferee: { 
    required: true, 
    type: [Object, null], 
    default: {} 
  },
  target: {
    type: String,
    default: null,
  },
})
</script>

<template lang="pug">
RouterLink(v-if="transferee" :to=" '/transferees/' + props.transferee.id " :target="props.target")
  template(v-if="slots.default")
    slot
  template(v-else)
    span {{ transferee.fullName }}
</template>